export default "__VITE_ASSET__C9zxmzuV__"